// frontend/src/pages/ShopMedicines.js
import React, { useEffect, useState, useRef } from "react";
import axiosInstance from "../api/axiosInstance";
import { useNavigate } from "react-router-dom";

export default function AdminConsumerProducts() {
  const navigate = useNavigate();

  const [items, setItems] = useState([]);
  const [search, setSearch] = useState("");
  const fileInputs = useRef({});

  const [selectedIds, setSelectedIds] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const role = localStorage.getItem("userRole");










  useEffect(() => {
    fetchItems();
  }, []);

  // ---------------- FETCH MEDICINES ----------------
  async function fetchItems() {
    try {
      const res = await axiosInstance.get("/consumer/list/");
      const data = Array.isArray(res.data) ? res.data : [];
      setItems(data);
      setSelectedIds([]);
      setSelectAll(false);
    } catch (err) {
      alert("Failed to load medicines");
    }
  }

  // ---------------- DELETE SINGLE MEDICINE ----------------
  async function handleDelete(id) {
    if (!window.confirm("Are you sure to delete this product?")) return;
    try {
      await axiosInstance.delete(`/consumer/delete/${id}/`);
      alert("product deleted");
      fetchItems();
    } catch {
      alert("Delete failed");
    }
  }

  // ---------------- IMAGE UPLOAD -------------------
  const handleImageChange = async (e, id) => {
    const file = e.target.files[0];
    if (!file) return;

    const formData = new FormData();
    formData.append("image", file);

    try {
      await axiosInstance.post(`/consumer/update-image/${id}/`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      fetchItems();
    } catch {
      alert("Image upload failed");
    }
  };

  // ---------------- FILTERED DATA -------------------
  const filtered = items.filter((it) =>
    (it.name ?? "").toLowerCase().includes(search.toLowerCase())
  );

const imageUrl = (img) =>
  img ? (img.startsWith("http") ? img : `http://127.0.0.1:8000${img}`) : null;


  // ---------------- CHECKBOX HELPERS ----------------
  const toggleSelect = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter((x) => x !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const toggleSelectAll = () => {
    if (!selectAll) {
      const allVisibleIds = filtered.map((m) => m.id);
      setSelectedIds(allVisibleIds);
    } else {
      setSelectedIds([]);
    }
    setSelectAll(!selectAll);
  };

  // ---------------- BULK DELETE ----------------
  const handleDeleteSelected = async () => {
    if (selectedIds.length === 0) {
      alert("No medicines selected");
      return;
    }

    if (!window.confirm("Delete selected medicines?")) return;

    try {
      await axiosInstance.post("/consumer/bulk-delete/", { ids: selectedIds });
      alert("Selected medicines deleted");
      fetchItems();
    } catch (err) {
      console.error(err);
      alert("Failed to delete selected medicines");
    }
  };

  const handleDeleteAll = async () => {
    if (!window.confirm("Delete ALL medicines?")) return;

    try {
      await axiosInstance.delete("/consumer/delete-all/");
      alert("All medicines deleted");
      fetchItems();
    } catch (err) {
      console.error(err);
      alert("Failed to delete all medicines");
    }
  };

  // ---------------- RENDER PAGE --------------------
  return (
    <div style={{ padding: 20 }}>
      {/* BACK BUTTON + ADD MEDICINE */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: 15,
        }}
      >
        <button
          onClick={() => navigate(-1)}
          style={{
            background: "#ddd",
            padding: "8px 15px",
            borderRadius: 6,
            border: "none",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          ← Back
        </button>

        {role === "admin" && (
          <button
            onClick={() => navigate("/admin/consumer")}
            style={{
              background: "green",
              color: "#fff",
              padding: "10px 16px",
              borderRadius: 8,
              border: "none",
              fontWeight: 700,
            }}
          >
            + Add Product
          </button>
        )}
      </div>

      {/* SEARCH BOX */}
      <input
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Search medicine..."
        style={{
          width: "100%",
          padding: 10,
          borderRadius: 8,
          border: "1px solid #ccc",
          marginBottom: 15,
        }}
      />

      {/* ADMIN BULK ACTIONS */}
      {role === "admin" && (
        <div style={{ marginBottom: 15, display: "flex", gap: 10 }}>
          <label>
            <input
              type="checkbox"
              checked={selectAll}
              onChange={toggleSelectAll}
              style={{ marginRight: 6 }}
            />
            Select All (visible)
          </label>

          <button
            onClick={handleDeleteSelected}
            style={{
              background: "orange",
              color: "#fff",
              padding: "6px 12px",
              borderRadius: 6,
              border: "none",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Delete Selected
          </button>

          <button
            onClick={handleDeleteAll}
            style={{
              background: "red",
              color: "#fff",
              padding: "6px 12px",
              borderRadius: 6,
              border: "none",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Delete ALL
          </button>
        </div>
      )}

      {/* GRID */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
          gap: 20,
        }}
      >
        {filtered.map((m) => {
          const sellingPrice = m.selling_price ?? m.price ?? 0;
          const mrp = m.mrp ?? m.price ?? 0;
          const discount =
            mrp && sellingPrice
              ? Math.round(((mrp - sellingPrice) / mrp) * 100)
              : 0;

          return (
            <div
              key={m.id}
              style={{
                border: "1px solid #eee",
                padding: 14,
                borderRadius: 10,
                background: "#fff",
              }}
            >
              {/* ADMIN SELECT CHECKBOX */}
              {role === "admin" && (
                <div style={{ marginBottom: 6, textAlign: "left" }}>
                  <input
                    type="checkbox"
                    checked={selectedIds.includes(m.id)}
                    onChange={() => toggleSelect(m.id)}
                  />{" "}
                  <span style={{ fontSize: 12 }}>Select</span>
                </div>
              )}

              {/* IMAGE + CLICK TO UPLOAD */}
              <div
                style={{
                  width: "100%",
                  height: 150,
                  background: "#f3f3f3",
                  borderRadius: 8,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                  overflow: "hidden",
                }}
                onClick={() =>
                  fileInputs.current[m.id] && fileInputs.current[m.id].click()
                }
              >
                {m.image ? (
                  <img
                    src={imageUrl(m.image)}
                    alt={m.name}
                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                  />
                ) : (
                  <span style={{ color: "#888" }}>No Image</span>
                )}
              </div>

              <input
                type="file"
                accept="image/*"
                ref={(el) => (fileInputs.current[m.id] = el)}
                style={{ display: "none" }}
                onChange={(e) => handleImageChange(e, m.id)}
              />

              {/* TITLE */}
              <h4 style={{ marginTop: 10 }}>{m.name}</h4>
              <p style={{ color: "#777" }}>
                {m.company} | {m.type}
              </p>

              {/* PRICE */}
              <div style={{ textAlign: "center", marginTop: 10 }}>
                <div>
                  <del style={{ color: "red" }}>{mrp ? `₹${mrp}` : ""}</del>
                </div>
                <div
                  style={{
                    fontSize: 18,
                    color: "green",
                    fontWeight: 700,
                  }}
                >
                  ₹{sellingPrice}
                </div>
                {discount > 0 && (
                  <div style={{ color: "orange", fontWeight: 700 }}>
                    {discount}% OFF
                  </div>
                )}
              </div>

              {/* ADMIN BUTTONS */}
              {role === "admin" && (
                <div style={{ marginTop: 12 }}>
                  <button
                    onClick={() => navigate(`/admin/consumer/${m.id}`)}

                    style={{
                      width: "100%",
                      background: "#0284C7",
                      color: "#fff",
                      padding: 8,
                      borderRadius: 6,
                      border: "none",
                      fontWeight: 700,
                      marginBottom: 8,
                    }}
                  >
                    Edit Details
                  </button>

                  <button
                    onClick={() => handleDelete(m.id)}
                    style={{
                      width: "100%",
                      background: "red",
                      color: "#fff",
                      padding: 8,
                      borderRadius: 6,
                      border: "none",
                      fontWeight: 700,
                    }}
                  >
                    Delete
                  </button>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
